module.exports = __webpack_public_path__ + "img/empty-state-icon.fb76a352.svg";